export default "__VITE_ASSET__BZbkww5k__"